import { Component } from 'react';

/**
 * Route-level error boundary. Prevents any single page from rendering a
 * blank white screen when an unhandled exception fires during render or
 * inside a lifecycle hook. Renders a lightweight fallback with the error
 * message and a Reload button.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Something went wrong.' };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const label = this.props.label || 'This page';
    return (
      <div
        className="min-h-screen flex items-center justify-center px-6"
        style={{ backgroundColor: '#F5F1EC' }}
        data-testid="error-boundary-fallback"
      >
        <div
          className="max-w-md w-full text-center"
          style={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: 12,
            padding: '32px 28px',
            boxShadow: '0 10px 30px rgba(13,31,60,0.06)',
          }}
        >
          <div
            className="inline-flex items-center justify-center rounded-full mb-4"
            style={{
              width: 48, height: 48,
              backgroundColor: 'rgba(196,26,26,0.10)',
              color: '#BA1A1A',
              fontSize: 22, fontWeight: 700,
            }}
          >!</div>
          <h1 className="text-lg font-semibold mb-2" style={{ color: '#0D1F3C' }}>
            {label} hit a snag
          </h1>
          <p className="text-sm mb-5" style={{ color: '#6B7280' }}>
            {this.state.message}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="text-sm font-semibold px-5 py-2 rounded-md hover:brightness-110 transition-all"
            style={{ backgroundColor: '#0D1F3C', color: '#FFFFFF' }}
            data-testid="error-boundary-reload"
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
